import { render, staticRenderFns } from "./AgentChatFAB.vue?vue&type=template&id=5ab412ec&scoped=true"
import script from "./AgentChatFAB.vue?vue&type=script&lang=ts"
export * from "./AgentChatFAB.vue?vue&type=script&lang=ts"
import style0 from "./AgentChatFAB.vue?vue&type=style&index=0&id=5ab412ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab412ec",
  null
  
)

export default component.exports